class NovaProductDailyValues {
  constructor() {
    this.previousUrl = window.location.href;
    this.currentVariantId = this.getCurrentVariantId();
    this.variantsIngredientsHtml = document.querySelectorAll(".product_ingredient_variant");
    this.productIngredientsHtml = document.querySelector(".product_ingredient_product ");
    this.variantsNutrientsHtml = document.querySelectorAll(".nutrient-elements_table--variant");
    this.productNutrientsHtml = document.querySelector(".nutrient-elements_table--product");
    this.productIngredientsSlidersHtml = document.querySelectorAll(".nova-slider--ingredients");

    this.initMutationObserver();
  }

  initMutationObserver() {
    new MutationObserver(() => {
      if (window.location.href !== this.previousUrl) {
        this.currentVariantId = this.getCurrentVariantId();
        this.previousUrl = window.location.href;
        this.updateIngredientsHtmlVisibility();
        this.updateNutrientsHtmlVisibility();
        this.updateIngredientsSlidersHtmlVisibility();
      }
    }).observe(document, {subtree: true, childList: true});
  }

  getCurrentVariantId() {
    return new URLSearchParams(window.location.search).get("variant");
  }

  updateIngredientsHtmlVisibility() {
    let variantIngredientsFound = false;

    this.variantsIngredientsHtml.forEach(element => {
      if (element.dataset.variantId === this.currentVariantId) {
        element.classList.remove("hidden");
        variantIngredientsFound = true;
      } else {
        element.classList.add("hidden");
      }
    });

    this.productIngredientsHtml?.classList.toggle("hidden", variantIngredientsFound);
  }

  updateNutrientsHtmlVisibility() {
    let variantNutrientsFound = false;

    this.variantsNutrientsHtml.forEach(element => {
      if (element.dataset.variantId === this.currentVariantId) {
        element.classList.remove("hidden");
        variantNutrientsFound = true;
      } else {
        element.classList.add("hidden");
      }
    });

    this.productNutrientsHtml?.classList.toggle("hidden", variantNutrientsFound);
  }

  updateIngredientsSlidersHtmlVisibility() {
    this.productIngredientsSlidersHtml.forEach(element => {
      if (element.dataset.variantId === this.currentVariantId) {
        element.classList.remove("hidden");
      } else {
        element.classList.add("hidden");
      }
    });
  }
}

new NovaProductDailyValues();
